import { render, staticRenderFns } from "./StrategicPrinciples.vue?vue&type=template&id=45dde7f2&"
import script from "./StrategicPrinciples.vue?vue&type=script&lang=js&"
export * from "./StrategicPrinciples.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports